import React, { useMemo, useState, useEffect, useCallback } from "react";
import MaterialReactTable from "material-react-table";
import axios from "axios";

const OmApoyo = ({ institucion }) => {
  const [Indicador, setIndicador] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔥 Fetch data
  const fetchData = useCallback(async () => {
    if (!institucion) return;

    try {
      setLoading(true);

      const response = await axios({
        method: "get",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url:
          "https://suadesarrollo.azurewebsites.net/api/ObtenerOmPorInstitucion/" +
          institucion,
      });

      console.log("DATA APOYO 👉", response.data);

      setIndicador(response.data || []);
    } catch (error) {
      console.error("ERROR ❌", error);
    } finally {
      setLoading(false);
    }
  }, [institucion]);

  // 🔥 useEffect correcto
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // 🔥 FILTRO CORREGIDO (NUMÉRICO)
  const filtro = useMemo(() => {
    return Indicador.filter((e) => Number(e.asistencial) === 2);
  }, [Indicador]);

  const grupos = ["A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8", "A9", "A10"];

  const columns = useMemo(
    () => [
      { accessorKey: "id", header: "Id" },
      {
        accessorKey: "estadoOportunidad",
        header: "Estado Oportunidad",
        filterVariant: "multi-select",
        filterSelectOptions: grupos,
      },
      { accessorKey: "origen", header: "Origen" },
      { accessorKey: "tipoVisita", header: "Tipo Visita" },
      { accessorKey: "descripcion", header: "Descripcion" },
    ],
    [],
  );

  return (
    <MaterialReactTable
      columns={columns}
      data={filtro}
      state={{ isLoading: loading }}
      enableRowSelection
      enableMultiRowSelection
      autoResetPageIndex={false} // 🔥 clave para paginador
      muiTablePaginationProps={{
        rowsPerPageOptions: [5, 10, 20],
      }}
      renderTopToolbarCustomActions={({ table }) => {
        const handleActualizar = async () => {
          const rows = table.getSelectedRowModel().flatRows;

          if (rows.length === 0) {
            alert("Selecciona al menos un registro");
            return;
          }

          try {
            for (const row of rows) {
              await axios({
                method: "put",
                url:
                  "https://suadesarrollo.azurewebsites.net/api/ActualizaIndicadorFicha?Id=" +
                  row.getValue("id"),
                data: {
                  ficha: "priorizado",
                },
              });
            }

            alert("Actualizado correctamente ✅");
            fetchData(); // 🔥 refresca sin reload
          } catch (error) {
            console.error(error);
            alert("Error al actualizar ❌");
          }
        };

        return (
          <g></g>
          //  <button className="btn btn-primary" onClick={handleActualizar}>
          //  Priorizar
          //</button>
        );
      }}
    />
  );
};

export default OmApoyo;
